import { ERPNetvisorIntegrationLockPeriod, RequestStatus, defaults } from 'typed/api';
import { combineReducers, entityLoadAllReducer, entityVoidAllReducer, networkActionReducer, switchReducers, synchronizableEnumReducer } from './utils';
import { Action } from 'typed/actions';
import { deepAssign } from 'typed/utils';

const
    cen = defaults.NetworkArrayOf(defaults.ERPFinancialCalculationError),
    biwn = defaults.PowerBIWorkspaceNetworkArray;

export default combineReducers({
    erpFinancialCalculationErrors: switchReducers(cen,
        entityLoadAllReducer(cen, 'LOAD_ALL_ERP_FINANCIAL_CALCULATION_ERRORS'),
        entityVoidAllReducer(cen, 'VOID_ALL_ERP_FINANCIAL_CALCULATION_ERRORS')
    ),
    erpNetvisorIntegrationLockPeriods: synchronizableEnumReducer(
        defaults.NetworkArrayOf(defaults.ERPNetvisorIntegrationLockPeriod),
        'LOAD_ALL_ERP_NETVISOR_INTEGRATION_LOCK_PERIODS',
        ERPNetvisorIntegrationLockPeriod as any,
        'ERPNetvisorIntegrationLockPeriod'
    ),
    powerBITokens: entityLoadAllReducer(defaults.NetworkArrayOf(defaults.PowerBIToken), 'LOAD_ALL_POWER_BI_TOKENS'),
    powerBIWorkspaces: switchReducers(biwn,
        networkActionReducer(biwn, 'LOAD_ALL_POWER_BI_WORKSPACES'),
        (state, action: Action<'LOAD_ALL_POWER_BI_WORKSPACES'>) => {
            const defaultState = state || biwn;

            if (action.type === 'LOAD_ALL_POWER_BI_WORKSPACES' && action.payload.status === RequestStatus.SUCCEEDED) {
                return deepAssign(defaultState, { Data: action.payload.response });
            }

            return defaultState;
        }
    )
});
